module.exports = __webpack_public_path__ + "static/media/5DPO5.733d4749.jpg";